import * as React from "react";

import { useRichTextContext } from "../RichTextContextProvider";

import { Button } from "@aws-amplify/ui-react";
import { MdFormatListNumbered } from "react-icons/md";

export interface OrderedListProps { }

export default function OrderedList(props: OrderedListProps) {
  const { } = props;
  const { setCurrentFormats, currentEditor, currentFormats } =
    useRichTextContext();

  const onOrderedList = React.useCallback(() => {
    if (!currentFormats || !currentEditor) {
      return;
    }
    const range = currentEditor.getSelection();
    if (!range) {
      return;
    }
    currentEditor.formatLine(
      range.index,
      range.length,
      "list",
      currentFormats.list === "ordered" ? false : "ordered"
    );
    setCurrentFormats?.(currentEditor.getFormat());
  }, [currentFormats, currentEditor]);

  return (
    <Button
      size="small"
      variation="link"
      padding={"xxs"}
      backgroundColor={
        currentFormats?.list === "ordered" ? "#efefef" : undefined
      }
      onClick={() => onOrderedList()}
    >
      <MdFormatListNumbered />
    </Button>
  );
}
